import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Row, Col, Container, Alert } from 'react-bootstrap';
import { Link, useParams, Navigate } from 'react-router-dom';
import AtosService from '../../../../../services/ato-auth';



const FormArquivo = () => {
    const [arquivo, setArquivo] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [numAto, setNumAto] = useState("");
    const handleUpload = (e) => setArquivo(e.target.files[0]);

    async function pegaNumAto(id) {
        const response = await AtosService.atoEdit(id);
            setNumAto(response.data["numAto"]);
    }

    useEffect(() => {
        pegaNumAto(id)
    }, [])

    const { id } = useParams();
    const montaForm = async () => {
        const ato = new FormData();
        ato.append("arquivo", arquivo);
        ato.append("numAto", numAto);
        return ato
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const ato = await AtosService.arquivo(id, numAto, dados)
            if (ato.data["numAto"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={2}>
                                <Col lg={10}>
                                    <Form.Group className="mb-3" controlId="arquivo">
                                        <Form.Label>Arquivo do Ato</Form.Label>
                                        <Form.Control
                                            required
                                            type="file"
                                            name="arquivo"
                                            onChange={handleUpload}
                                            accept="application/pdf"
                                        />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <br />
                        <Link to={'/restrito/atos/listar'}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Ato editado com sucesso!</Alert>
                <Navigate to={'/restrito/atos/listar'} />
            </Fragment>
        )
    }
}

export default FormArquivo